<template>
    <div class="phonefoot">
      <div class="friend_url">
        <div class="title">友情链接：</div>
        <div class="friend_group">
          <a href="" title="汉文大藏">汉文大藏</a>
          <div class="line"></div>
          <a href="" title="经佛学辞典">经佛学辞典</a>
        </div>
        <div class="copyright textover">Copyright©2020 佛法修证心要, 版权所有, 湘ICP备19005325号</div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "phone_footer",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
.phonefoot{
  width:100%;
  background: #c9a168;
  height:2.37rem;
  padding:0.35rem 0.28rem;
  box-sizing: border-box;
  .title{
    font-size:0.24rem;
    color:#fff;
    letter-spacing: 2px;
  }
  .friend_url{
    height:100%;
    position: relative;
  }
  .friend_group{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top:0.2rem;
    a{
      font-size:0.24rem;
      color:#fff;
      border-bottom:1px solid #fff;
    }
    .line{
      background: #fff;
      width:1px;
      height:0.3rem;
      margin:0 0.8rem;
    }
  }
  .copyright{
    font-size:0.22rem;
    color:#fff;
    position: absolute;
    bottom:0;
    width:100%;
    line-height: 0.22rem;
    height:0.22rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/phone_footer.vue